import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { iconList } from './icon-list';

const ICON_ID = iconList.IconFile2;
const namespace = 'ui-pdp-icon ui-pdp-icon--icon-file';

const IconFile = ({ className = '' }) => (
  <svg
    className={classnames(className, namespace)}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M6.40039 6.09509H13.6004V4.89509H6.40039V6.09509Z" fill="black" fillOpacity="0.9" />
    <path d="M13.6004 9.00012H6.40039V7.80012H13.6004V9.00012Z" fill="black" fillOpacity="0.9" />
    <path d="M10.0004 12.0001H6.40039V10.8001H10.0004V12.0001Z" fill="black" fillOpacity="0.9" />
    <path
      d="M13.8963 15.1395L18.0635 11L19 11.9303L13.8963 17L11 14.1229L11.9365 13.1927L13.8963 15.1395Z"
      fill="black"
      fillOpacity="0.9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.40039 1.3999C3.40039 1.12376 3.62425 0.899902 3.90039 0.899902H16.1004C16.3765 0.899902 16.6004 1.12376 16.6004 1.3999V7.9999H15.4004V2.0999H4.60039V17.3999H10.0004V18.5999H3.90039C3.62425 18.5999 3.40039 18.376 3.40039 18.0999V1.3999Z"
      fill="black"
    />
  </svg>
);

IconFile.propTypes = {
  className: string,
};

IconFile.ICON_ID = ICON_ID;

export default React.memo(IconFile);
export { IconFile };
